import React, { useEffect, useRef, useState } from "react";
import { Document, Page, pdfjs } from "react-pdf";
import pdfWorker from "pdfjs-dist/build/pdf.worker.entry";
import { FiDownload, FiMail, FiPhone } from "react-icons/fi";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = pdfWorker;

const content = {
  zh: {
    pdf: "/resumes/Eunice-Lu-Event-Resume-ZH.pdf",
    pdfLabel: "繁體中文履歷",
    download: "下載履歷",
    loading: "正在載入履歷...",
    error: "PDF 暫時無法載入，請使用下載按鈕開啟。",
  },
  en: {
    pdf: "/resumes/Eunice-Lu-Event-Resume-EN.pdf",
    pdfLabel: "English resume",
    download: "Download resume",
    loading: "Loading resume...",
    error: "The PDF cannot be displayed right now. Please use the download button.",
  },
};

function Resume({ language }) {
  const copy = content[language];
  const frameRef = useRef(null);
  const [numPages, setNumPages] = useState(null);
  const [pageWidth, setPageWidth] = useState(900);

  useEffect(() => {
    const updateWidth = () => {
      if (!frameRef.current) return;
      setPageWidth(Math.min(frameRef.current.offsetWidth - 32, 920));
    };

    updateWidth();
    window.addEventListener("resize", updateWidth);
    return () => window.removeEventListener("resize", updateWidth);
  }, []);

  return (
    <main className="resume-page">
      <section className="resume-frame-wrap site-container">
        <div className="resume-top-action">
          <a href={copy.pdf} download className="primary-action">
            <FiDownload aria-hidden="true" />
            {copy.download}
          </a>
        </div>
        <div className="resume-pdf-stage" ref={frameRef} aria-label={copy.pdfLabel}>
          <Document
            file={copy.pdf}
            loading={<div className="resume-pdf-message">{copy.loading}</div>}
            error={<div className="resume-pdf-message">{copy.error}</div>}
            onLoadSuccess={({ numPages: nextNumPages }) => setNumPages(nextNumPages)}
          >
            {Array.from(new Array(numPages || 0), (_, index) => (
              <Page
                className="resume-pdf-page"
                key={`page_${index + 1}`}
                pageNumber={index + 1}
                renderTextLayer={false}
                width={pageWidth}
              />
            ))}
          </Document>
        </div>
        <div className="resume-contact-strip">
          <a href="mailto:eunicelu312@outlook.com">
            <FiMail aria-hidden="true" />
            eunicelu312@outlook.com
          </a>
          <a href="tel:+85266872763">
            <FiPhone aria-hidden="true" />
            +852 6687 2763
          </a>
        </div>
      </section>
    </main>
  );
}

export default Resume;
